import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getSisterProjectsPage = async () => {
  const data = await fetchData(ENDPOINTS.GET.SISTER_PROJECTS, {
    method: METHODS.GET,
  });
  return data;
};
